import { Navigate } from 'react-router-dom';

interface AuthRouteProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
}

export function ProtectedRoute({ children, isAuthenticated }: AuthRouteProps) {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export function PublicRoute({ children, isAuthenticated }: AuthRouteProps) {
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

interface AdminRouteProps {
  children: React.ReactNode;
  isAdmin: boolean;
}

export function AdminRoute({ children, isAdmin }: AdminRouteProps) {
  if (!isAdmin) {
    return <Navigate to="/settings/personal-information" replace />;
  }

  return children;
}
